import { Component, EventEmitter, Input, OnInit, Output, ViewChild, AfterViewInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-radio-button-table',
  templateUrl: './radio-button-table.component.html',
  styleUrls: ['./radio-button-table.component.scss']
})
export class RadioButtonTableComponent implements OnInit, AfterViewInit {

  @ViewChild('validationForm') validationForm: any;

  @Input() invalidForm: any;
  @Input() formItem: any;
  @Input() formId: any;
  @Output() callUpdate = new EventEmitter();
  @Output() invalidFormChange = new EventEmitter<boolean>();

  options: any;
  radioOptions: any;
  optionsLabelArray: any;
  answersIndex: any;
  optionItemLabel: any;
  formTitle: string;
  isRequired: string;
  radioButtonOption: any;
  variableModel: string = "1";

  formGroupTable;

  yesNoLabel: boolean;

  constructor() {
    //why is this empty?
  }

  ngOnInit() {
    const isRadioYesNo = this.formItem.item.datasource.name;
    if (isRadioYesNo === 'Yes/No' || isRadioYesNo === 'Yes/No To Symptoms') {
      this.yesNoLabel = true;
    } else {
      this.yesNoLabel = false;
    }
    this.isRequired = this.formItem.item.isRequired;
    delete this.formItem.boolValue;
    delete this.formItem.value;

    this.formTitle = this.formItem.item.labelField;

    this.options = this.formItem.formListInstanceItem;
    const group: any = {};
    if(this.options){
      this.options.forEach((question, i) => {
            group[i] = question.item.isRequired ? new FormControl(question.value || '', Validators.required)
              : new FormControl(question.value || '');
          });
    }
    this.formGroupTable = new FormGroup(group);
    this.formGroupTable.statusChanges.subscribe((status) => {
      this.emitFormStatus(status);
    });

    this.radioOptions = this.formItem.item.datasource.datasourcesItems;
    this.optionsLabelArray = this.getLabelOptions(this.formItem.item.datasource.datasourcesItems);
    this.answersIndex = this.optionsLabelArray.length;

    this.radioButtonOption = this.formItem.formListInstanceItem;

  }

  get selectedOptions() {

    if (!this.radioButtonOption) return false;

    return !!this.radioButtonOption.filter(option => {
      return option.boolValue === true;
    })[0];

  }

  updateConditional(option: any, i: any) {
    option.boolValue = true;
     if (option.item.isConditional) {
       this.callUpdate.emit();
     }
    if (this.isRequired) {
      // We have to pass true if the form is invalid, so we negate the boolean of selected options
      this.invalidFormChange.emit(!this.selectedOptions);
    }
  }

  getLabelOptions(data: any) {
    return data.map(option => {
      return option.labelField;
    });
  }

  emitFormStatus(status) {
    status = status === 'INVALID' ? true : false;
    this.invalidFormChange.emit(status);
  }

  // Use this cycle because the view has to render the conditionals
  // The HTML <template> (or ng-container) element is a mechanism for holding client-side content
  // that is not to be rendered when a page is loaded but may subsequently be instantiated
  // during runtime using JavaScript.
  ngAfterViewInit() {
    setTimeout(_ => {
      if (this.isRequired && this.radioButtonOption) {
        this.invalidFormChange.emit(!this.selectedOptions);
      }
    });
  }
}
